"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs_js_1 = require("../configs/configs.js");
const Path_1 = require("../Util/Path");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const ErrorCodes_1 = require("../Enum/ErrorCodes");
const TooManyValuationError_1 = require("../Error/TooManyValuationError");
class ValuationRepository {
    constructor(config, httpClient, valuationTransformer, errorTransformer) {
        this.config = config;
        this.httpClient = httpClient;
        this.transformer = valuationTransformer;
        this.errorTransformer = errorTransformer;
    }
    static create(config, container) {
        return new this(config, container.get('http_client'), container.get('transformer.valuation_to_data'), container.get('transformer.axios_to_error'));
    }
    /**
     * Create valuation.
     *
     * @returns {Promise<Valuation>}
     */
    create(valuation) {
        const url = Path_1.default.route(configs_js_1.configs.endpoints.valuation, {});
        return this.httpClient.post(url, this.transformer.to(valuation))
            .catch(err => {
            if (err.response.data.code === ErrorCodes_1.ErrorCodes.TOO_MANY_VALUATIONS) {
                throw new TooManyValuationError_1.default(err.message);
            }
            throw this.errorTransformer.to(err);
        })
            .then(res => this.transformer.from(res.data));
    }
    /**
     * Get existing valuation.
     *
     * @param {string} token
     * @returns {Promise<Valuation>}
     */
    get(token) {
        const url = Path_1.default.route(configs_js_1.configs.endpoints.valuation, {
            id: token
        });
        return this.httpClient.get(url)
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then(res => this.transformer.from(res.data));
    }
    /**
     * Clone existing valuation.
     *
     * @param {string} token
     * @returns {Promise<Valuation>}
     */
    clone(token) {
        const url = Path_1.default.route(configs_js_1.configs.endpoints.valuationClone, {
            id: token
        });
        return this.httpClient.get(url)
            .catch(err => {
            if (err.response.data.code === ErrorCodes_1.ErrorCodes.TOO_MANY_VALUATIONS) {
                throw new TooManyValuationError_1.default(err.message);
            }
            throw this.errorTransformer.to(err);
        })
            .then(res => this.transformer.from(res.data));
    }
    /**
     * Update existing valuation.
     *
     * @param {Valuation} valuation
     * @param {bool} reloadFromProvider
     * @returns {Promise<Valuation>}
     */
    update(valuation, reloadFromProvider) {
        const updateFromDP = reloadFromProvider ? { "updateFromDataProvider": true } : '';
        const url = Path_1.default.route(configs_js_1.configs.endpoints.valuation, {
            id: valuation.getToken()
        }, updateFromDP);
        return this.httpClient.patch(url, this.transformer.to(valuation))
            .catch(err => {
            if (err.response.data.code === ErrorCodes_1.ErrorCodes.TOO_MANY_VALUATIONS) {
                throw new TooManyValuationError_1.default(err.message);
            }
            throw this.errorTransformer.to(err);
        })
            .then(res => this.transformer.from(res.data));
    }
}
exports.default = ValuationRepository;
Mixin_1.default(ValuationRepository, IContainerInjection_1.default);
